import { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { CheckCircle2, ScanFace } from "lucide-react";
import { LangToggle, ThemeToggle } from "../components/controls/Toggles";
import { NeuCard } from "../components/neu/Neu";
import { InviteGate } from "../features/onboarding/InviteGate";
import { JoinForm } from "../features/onboarding/JoinForm";
import { useJoinFlow } from "../features/onboarding/useJoinFlow";

export default function JoinPage() {
  const { t } = useTranslation();
  const { token: routeToken } = useParams();
  const flow = useJoinFlow(routeToken);

  useEffect(() => {
    if (routeToken) flow.verify(routeToken);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [routeToken]);

  return (
    <div className="min-h-[100dvh] bg-background px-5 py-10">
      <div className="mx-auto max-w-2xl">
        <div className="mb-6 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="neu flex h-12 w-12 items-center justify-center rounded-2xl p-0">
              <ScanFace className="h-6 w-6 text-primary" />
            </div>
            <div>
              <p className="text-xl font-black">{t("join.title")}</p>
              <p className="text-xs text-muted-foreground">{t("join.subtitle")}</p>
            </div>
          </div>
          <div className="flex gap-2">
            <LangToggle />
            <ThemeToggle />
          </div>
        </div>

        {flow.done ? (
          <NeuCard className="animate-pop text-center" data-testid="join-done">
            <CheckCircle2 className="mx-auto h-10 w-10 text-success" />
            <p className="mt-4 text-lg font-bold">{t("join.submitted")}</p>
            <Link to="/login" className="mt-4 inline-block text-sm font-semibold text-primary">
              {t("auth.signIn")}
            </Link>
          </NeuCard>
        ) : flow.invite ? (
          <JoinForm
            invite={flow.invite}
            frames={flow.frames}
            setFrames={flow.setFrames}
            submit={flow.submit}
            busy={flow.busy}
            error={flow.error}
          />
        ) : (
          <InviteGate
            token={flow.token}
            setToken={flow.setToken}
            verify={flow.verify}
            busy={flow.busy}
            error={flow.error}
          />
        )}
      </div>
    </div>
  );
}
